<p-dialog
  (visibleChange)="handleVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '70rem', maxWidth: '95vw' }"
  [visible]="visible()"
  header="Wybór elementów">
  <app-table
    (selectionChangeEvent)="handleSelectionChangeEvent($event)"
    [config]="config" />

  <div class="mt-4 flex justify-end gap-3">
    <p-button
      (onClick)="cancelEvent.emit()"
      appPrimengButton
      label="Anuluj"
      severity="secondary" />

    <p-button
      (onClick)="handleSubmitClick()"
      appPrimengButton
      label="Dodaj zaznaczone" />
  </div>
</p-dialog>
